import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { api, dt } from "@/lib/api";
import { PageHeader, Card, Table, StatusBadge, AckBadge, Money, Tag } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

const FILTERS = [["", "Semua"], ["waiting_receiving", "Menunggu Penerimaan"], ["verified", "Masuk stok"], ["cancelled,refunded", "Dibatalkan/Refund"]];

export default function Purchases() {
  const { can } = useAuth();
  const [rows, setRows] = useState([]);
  const [st, setSt] = useState("");
  const nav = useNavigate();
  useEffect(() => { api.get("/purchases", { params: st ? { status: st } : {} }).then((r) => setRows(r.data)); }, [st]);
  return (
    <div>
      <PageHeader title="Pembelian" sub="Pembelian dari supplier. Kas langsung berkurang; stok baru bertambah begitu barang diterima.">
        {can("purchase.create") && <Link to="/purchases/new" className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-emerald-700 transition-colors" data-testid="new-purchase-button"><Plus size={16} /> Pembelian baru</Link>}
      </PageHeader>
      <div className="flex gap-1.5 mb-3 flex-wrap">
        {FILTERS.map(([v, l]) => <button key={v} onClick={() => setSt(v)} data-testid={`purchase-filter-${v || "all"}`} className={`px-3 py-1.5 text-xs font-semibold rounded-full border transition-colors ${st === v ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 text-slate-600 hover:border-slate-400"}`}>{l}</button>)}
      </div>
      <Card>
        <Table testid="purchases-table" rows={rows} onRow={(r) => nav(`/purchases/${r.id}`)} cols={[
          { h: "Kode", r: (r) => <span className="num text-xs font-semibold text-emerald-700">{r.code}</span> },
          { h: "Tanggal", k: "date" },
          { h: "Jenis", r: (r) => <Tag tone={r.kind === "central" ? "indigo" : "amber"}>{r.kind === "central" ? "Pusat" : "Langsung outlet"}</Tag> },
          { h: "Supplier", k: "supplier_name" },
          { h: "Tujuan", k: "destination_name" },
          { h: "Barang", r: (r) => <span className="text-xs">{r.lines.map((l) => `${l.item_name} ${l.qty} ${l.unit}`).join(", ")}</span>, cls: "max-w-xs truncate" },
          { h: "Total", right: true, r: (r) => <Money v={r.total} className="font-semibold" /> },
          { h: "Status", r: (r) => <span className="flex gap-1 flex-wrap"><StatusBadge s={r.status} />{r.status === "verified" && r.kind !== "consignment" && <AckBadge doc={r} />}{r.discrepancy && <Tag tone="rose">Selisih</Tag>}{r.flagged && r.status === "verified" && <Tag tone="rose">Flag</Tag>}</span> },
          { h: "Dibuat", r: (r) => <span className="text-xs text-slate-500">{r.created_by?.name} · {dt(r.created_at)}</span> },
        ]} />
      </Card>
    </div>
  );
}
